import React from "react";
import DecisionTree from "../../components/decision-tree/DecisionTree";
import content from "../../data/content/guarantees-and-troubleshooting-guides";
import analyticsTrigger from "../../utils/analytics/trigger/analyticsTrigger";
import buildPathName from "../../utils/buildPathName";

const analyticsNameEventMap = {
  electricalTv: "tv",
  electricalComputingApple: "apple computing",
  electricalComputingNonApple: "non-apple computing",
  electricalAudio: "audio guarantees",
  electricalLarge: "large",
  electricalSmall: "small",
  electricalLighting: "lighting",
  electricalOther: "electrical other",
  indoorFurnitureSofas: "sofas, armchairs & sofa beds",
  indoorFurnitureMattress: "mattress & divan",
  indoorFurnitureFilled: "filled bedding",
  indoorFurnitureCurtains: "curtains & blinds",
  cookware: "cookware & bathrooms",
  cookwareLifetime: "cookware lifetime",
  bathroomLifetime: "bathroom lifetime",
  prams: "buggies & travel",
  pramsGuarantees: "prams, pushchairs and car seats",
  nurseryTravel: "nursery supplier contact",
  outdoorFurniture: "outdoor furniture",
  luggage: "luggage",
};

export const metadata = {
  title: `Guarantees | Customer Services`,
  description: `Have a question? We're here to help with all your queries, from delivery and returns to orders and your online account and your My John Lewis membership.`,
};

function Guarantees() {
  const analyticsHandler = elements => {
    if (elements) {
      analyticsTrigger(
        "dataStateChange",
        buildPathName(":troubleshooting guides", analyticsNameEventMap, elements),
        {},
        "pageload",
      );
    }
  };

  return (
    <DecisionTree
      showBack={false}
      content={content}
      startKey="guaranteesAndTroubleshootingGuides"
      defaultBackText="Guarantees and Troubleshooting guides"
      onTreeUpdate={analyticsHandler}
    />
  );
}

Guarantees.metadata = metadata;

export default Guarantees;
